import {Routes,Route} from 'react-router-dom';
import HOME from './Pages/Home';
import PRODUCTS from './Pages/Products';
import ABOUT_US from './Pages/About_us';
import GALLERY from './Pages/Gallery';
import ORDER from './Pages/order_with_us';


function App() {
  return (
    <>
    <Routes>
      <Route exact path="/" element = {<HOME/>} />
      <Route path="/about_us" element = {<ABOUT_US/>} />
      <Route path="/products" element={<PRODUCTS/>} />
      <Route path="/gallery" element = {<GALLERY/>} />
      <Route path="/order" element = {<ORDER/>} />
    </Routes>
    
    </>
  );
}

export default App;